function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { hideOthers } from "aria-hidden";
/**
 * Acts as a polyfill for `aria-modal` by watching for added modals and hiding any surrounding DOM elements with `aria-hidden`.
 */

export function watchModals(selector) {
  if (selector === void 0) {
    selector = 'body';
  }
  /**
   * Listen for additions to the child list of body. This is where providers render modal portals.
   * When one is added, see if there is a modal inside it, if there is, then hide everything else from screen readers.
   * If there was already a modal open and a new one was added, undo everything that the previous modal had hidden and hide based on the new one.
   *
   * If a modal container is removed, then undo the hiding based on the last hide others. Check if there are any other modals still around, and
   * hide based on the last one added.
   */


  var target = document.querySelector(selector);
  var config = {
    childList: true
  };
  var modalContainers = [];
  var undo;
  var observer = new MutationObserver(function (mutationRecord) {
    var _iterator = _createForOfIteratorHelper(mutationRecord),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var mutation = _step.value;

        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          var addNode = Array.from(mutation.addedNodes).find(function (node) {
            return node.querySelector == null ? void 0 : node.querySelector('[aria-modal="true"], [data-ismodal]');
          });

          if (addNode) {
            modalContainers.push(addNode);
            var modal = addNode.querySelector('[aria-modal="true"], [data-ismodal]');

            if (undo) {
              undo();
            }

            undo = hideOthers(modal);
          }
        } else if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
          (function () {
            var removedNodes = Array.from(mutation.removedNodes);
            var nodeIndexRemove = modalContainers.findIndex(function (container) {
              return removedNodes.includes(container);
            });

            if (nodeIndexRemove >= 0) {
              undo();
              modalContainers = modalContainers.filter(function (val, i) {
                return i !== nodeIndexRemove;
              });

              if (modalContainers.length > 0) {
                var _modal = modalContainers[modalContainers.length - 1].querySelector('[aria-modal="true"], [data-ismodal]');

                undo = hideOthers(_modal);
              } else {
                undo = undefined;
              }
            }
          })();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
  observer.observe(target, config);
}